<div class="chat-bubble left">
    <div [innerHTML]="text" class="answer"></div>
</div>